import { Numberedlist } from '../../../components/NumberedList'
import { SubSection } from '../../../components/SubSection'
import { TranscriptionScriptPDF } from '../../../components/TranscriptionScriptPDF'
import { Banner } from '../../../components/Banner/Banner'
import { View } from '@react-pdf/renderer'
import { tw } from '../../../utils'
import { useReportPdfContext } from '../../../report-pdf-provider'
import { ReportType } from '../../../../report-pdf'

export const ThirdPage = ({ data }) => {
  const { t, person, type } = useReportPdfContext()
  const planType = t('planType')
  const numberedList = [
    {
      title: t('initial-report:sectionOne.introduction.numberedList.one.title'),
      content: t(
        'initial-report:sectionOne.introduction.numberedList.one.content',
      ),
    },
    {
      title: t('initial-report:sectionOne.introduction.numberedList.two.title'),
      content: (
        <TranscriptionScriptPDF script="initial-report:sectionOne.introduction.numberedList.two.content" />
      ),
    },
  ]

  return (
    <View>
      <View style={tw('px-12')}>
        <SubSection
          classes="text-primary"
          title={t('initial-report:sectionOne.introduction.title')}
        >
          <View style={tw('flex flex-col gap-4')}>
            <TranscriptionScriptPDF script="initial-report:sectionOne.introduction.healthyAging" />
            <Numberedlist column list={numberedList} />
            <TranscriptionScriptPDF
              scriptProps={{
                opName: person.socialReferent.fullName,
                planType: planType,
              }}
              script="initial-report:sectionOne.introduction.definition"
            />
            {ReportType[type] === ReportType.care && (
              <TranscriptionScriptPDF
                scriptProps={{ opName: person.socialReferent.fullName }}
                script="initial-report:sectionOne.introduction.careDescription"
              />
            )}
          </View>
        </SubSection>
      </View>
      <Banner title={t('initial-report:sectionOne.introduction.banner')} />
    </View>
  )
}
